const MapsProviderEnum = {
  Google: 'google',
  MapBox: 'mapbox'
}

export default MapsProviderEnum
